/**
 * Imports only basis styles (helpers)
 *
 */

import './dnb-ui-basis.scss'
